(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
require('./plugins/share');
require('./plugins/smart-resize');

var Util 	= require('./modules/util');
var Theme = require('./modules/theme');
var Map 	= require('./modules/map');

jQuery(document).ready(function($) {

	Util.detectBrowser();

	Theme.init();

	Map.init();


});
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_c7fdd742.js","/")